exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amap-info-content-inner {\n  padding-top: 15px;\n  font-size: 14px;\n  color: #333;\n  word-break: break-all;\n}\n.amap-luopan {\n  display: none;\n}\n", ""]);

// exports
